import type { Sticker } from '../types';

export const surprise: Sticker[] = [
  {
    id: 16001,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/001-surprise.png',
    name: 'Niespodzianka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16002,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/002-surprise.png',
    name: 'Prezent',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16003,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/003-surprise.png',
    name: 'Pudełko z Niespodzianką',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16004,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/004-garland.png',
    name: 'Girlanda',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16005,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/005-party popper.png',
    name: 'Konfetti',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16006,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/006-surprise.png',
    name: 'Magiczne Pudełko',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16007,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/007-party horn.png',
    name: 'Trąbka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16008,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/008-surprise.png',
    name: 'Tajemnicze Pudełko',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16009,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/009-surprise.png',
    name: 'Kolorowa Niespodzianka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16010,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/010-surprise.png',
    name: 'Radosna Niespodzianka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16011,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/011-surprise.png',
    name: 'Świąteczna Niespodzianka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16012,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/012-happy.png',
    name: 'Szczęśliwa Niespodzianka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16013,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/013-surprise.png',
    name: 'Urodzinowa Niespodzianka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16014,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/014-surprise.png',
    name: 'Magiczna Niespodzianka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16015,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/015-chest.png',
    name: 'Skrzynia Skarbów',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16016,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/016-surprise.png',
    name: 'Specjalna Niespodzianka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16017,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/017-flower.png',
    name: 'Kwiatowa Niespodzianka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16018,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/018-letter.png',
    name: 'List z Niespodzianką',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16019,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/019-surprise.png',
    name: 'Wyjątkowa Niespodzianka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 16020,
    url: 'https://stickers.nauczniaczek.pl/colections/13725204-surprise/png/020-question.png',
    name: 'Zagadkowa Niespodzianka',
    category: 'surprise',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];